import axios from '../api/axios';
import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { Annonce } from '../models/AnnonceModel';
import '../css/gestionFacture.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faPaperPlane,faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import LoaderAnnonce from './LoaderAnnonce';
import { getAllAnnonceByUser, getAllAnnoncesUser } from '../services/Annonce_service';
import { DatePicker, Popover, Button } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { paginate } from '../utils/functions/pagination';
import { PaginationControls } from './PaginationControls';
import { getAvoirs, downloadFacture as downloadAvoirFacture, openFactureInNewTab } from '../services/Avoir_service';
import { FaDownload, FaEye, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import EditFactureModal from './EditFacureModal';
import EditAnnonceModal from './EditAnnonceModal';
import EmailReminderModal from './gestion-annonce/EmailReminderModal';
import { trackMenuClick } from '../services/menuClick_service';
import ClientsPurchasesTable from './ClientsPurchasesTable';

const API_URL = process.env.REACT_APP_API_URL;

interface GestionFactureUserProps {
  onNombreFacturesChange?: (nombre: number) => void;
}

interface SimpleCreditNote {
  id: number;
  statut?: string;
  montant_avoir?: number | string;
  annonce?: any;
  createdAt?: string;
}

const GestionFactureUser: React.FC<GestionFactureUserProps> = ({ onNombreFacturesChange }) => {
  const [filterDate, setFilterDate] = useState('');
  const [annonces, setAnnonces] = useState<Annonce[]>([]);
  const [filteredAnnonces, setFilteredAnnonces] = useState<Annonce[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [role, setRole] = useState<string>('');
  const [username, setUsername] = useState(localStorage.getItem('username') || '');
  const [searchQuery, setSearchQuery] = useState('');
  const [filterYear, setFilterYear] = useState('');
  const [filterMonth, setFilterMonth] = useState('');
  const [filterDay, setFilterDay] = useState('');
  const { RangePicker } = DatePicker;
  const [filterDateRange, setFilterDateRange] = useState<[Dayjs | null | undefined, Dayjs | null | undefined]>([null, null]);

  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [day, setDay] = useState('');
  const [selectedAnnonces, setSelectedAnnonces] = useState<string[]>([]);

  const [sommeTTCJourAlo, setSommeTTCJourAlo] = useState<number>(0);
  const [sommeHTJourAlo, setSommeHTJourAlo] = useState<number>(0);
  const [sommeMois, setSommeMois] = useState<number>(0);
  const [sommeMoisPrecedents, setSommeMoisPrecedents] = useState<number>(0);
  const [sommeRecherchee, setSommeRecherchee] = useState<number>(0);
  const [sommeTTCJourLegale, setSommeTTCJourLegale] = useState(0);
  const [sommeHTJourLegale, setSommeHTJourLegale] = useState<number>(0);
  const [sommeMoisLegale, setSommeMoisLegale] = useState(0);
  const [sommeMoisPrecedentsLegale, setSommeMoisPrecedentsLegale] = useState(0);
  const [sommeRechercheeLegale, setSommeRechercheeLegale] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState<'factures' | 'avoirs' | 'annuaire'>('factures');
  const [creditNotes, setCreditNotes] = useState<SimpleCreditNote[]>([]);
  const [loadingAvoirs, setLoadingAvoirs] = useState<boolean>(false);
  const [selectedAvoirs, setSelectedAvoirs] = useState<number[]>([]);
  const [currentAvoirsPage, setCurrentAvoirsPage] = useState<number>(1);
  const [filterStatus, setFilterStatus] = useState<string>('');
  const [filterPayment, setFilterPayment] = useState<'all' | 'paid' | 'unpaid'>('all');

  const [showModal, setShowModal] = useState(false);
  const [selectedFacture, setSelectedFacture] = useState<any>(null);
  const [Factures, setFactures] = useState<any[]>([]);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedAnnonce2, setSelectedAnnonce2] = useState<any>(null);
  const [currentAnnonce, setCurrentAnnonce] = useState<Annonce | null>(null);
  const [isModalOpen2, setIsModalOpen2] = useState<boolean>(false);
  const [searchName, setSearchName] = useState('');

  const totalCount = filteredAnnonces.length;
  const paidCount = filteredAnnonces.filter(f => f.isPaid === true).length;
  const unpaidCount = filteredAnnonces.filter(f => f.isPaid === false || f.isPaid === undefined).length;

  // ── Helpers ────────────────────────────────────────────
  const handleClickReminder = (annonce: Annonce) => { setCurrentAnnonce(annonce); setIsModalOpen2(true); };
  const openEditModal = (facture?: any) => { setSelectedFacture(facture || null); setShowModal(true); };
  const getTarifReduitTTC = (v?: number) => v === undefined ? 0 : +(v * 0.75).toFixed(2);
  const getTarifReduitHT  = (v?: number) => v === undefined ? 0 : +(v * 0.75).toFixed(2);

  // ── Fetch annonces ─────────────────────────────────────
  useEffect(() => {
    const fetchAnnonces = async () => {
      try {
        setLoading(true);
        const roleFromStorage = localStorage.getItem('role');
        setRole(roleFromStorage || '');
        const emailadmin = 'site.terrier+admin@gmail.com';
        let data: any;
        if (roleFromStorage === 'CLIENT') {
          data = await getAllAnnonceByUser();
        } else if (roleFromStorage === 'ADMIN') {
          data = await getAllAnnoncesUser();
          data = (data || []).filter((a: any) => a.email !== emailadmin);
        } else {
          toast.error('Rôle non reconnu'); setLoading(false); return;
        }
        const sorted = (data || []).sort((a: any, b: any) =>
          new Date(b.dateFacture).getTime() - new Date(a.dateFacture).getTime()
        );
        setAnnonces(sorted);
        setFilteredAnnonces(sorted);
        const countPdf = (data || []).filter((a: any) => a.pdfFactureAlo?.trim()).length;
        if (onNombreFacturesChange) onNombreFacturesChange(countPdf);
      } catch {
        toast.error('Erreur lors de la récupération des annonces');
        if (onNombreFacturesChange) onNombreFacturesChange(0);
      } finally {
        setLoading(false);
      }
    };
    fetchAnnonces();
  }, [onNombreFacturesChange]);

  // ── Calcul sommes ──────────────────────────────────────
  useEffect(() => {
    const now = dayjs();
    const moisEnCours = now.month();
    const anneeEnCours = now.year();
    let ttcJAlo = 0, htJAlo = 0, mois = 0, moisPrecs = 0, recherche = 0;
    let ttcJLeg = 0, htJLeg = 0, moisLeg = 0, moisPrecsLeg = 0, rechercheLeg = 0;

    annonces.forEach(a => {
      const d = dayjs(a.dateFacture);
      if (!d.isValid()) return;
      const ttc = Number(a.montantTTC ?? 0);
      const ht = Number(a.montantHTannonce ?? 0);
      const rTTC = getTarifReduitTTC(a.legalMoTTC ?? 0);
      const rHT = getTarifReduitHT(a.legalMoHT ?? 0);
      if (d.isSame(now, 'day'))   { ttcJAlo += ttc; htJAlo += ht; ttcJLeg += rTTC; htJLeg += rHT; }
      if (d.isSame(now, 'month')) { mois += ttc; moisLeg += rTTC; }
      const mp = moisEnCours === 0 ? 11 : moisEnCours - 1;
      const ap = moisEnCours === 0 ? anneeEnCours - 1 : anneeEnCours;
      if (d.year() === ap && d.month() === mp) { moisPrecs += ttc; moisPrecsLeg += rTTC; }
    });

    const hasFilter = searchTerm.trim() || searchQuery.trim() || (filterDateRange && (filterDateRange[0] || filterDateRange[1]));
    if (hasFilter) {
      filteredAnnonces.forEach(a => {
        recherche += a.montantTTC ?? 0;
        rechercheLeg += getTarifReduitTTC(a.legalMoTTC ?? 0);
      });
    }

    setSommeTTCJourAlo(+ttcJAlo); setSommeHTJourAlo(+htJAlo);
    setSommeMois(+mois); setSommeMoisPrecedents(+moisPrecs); setSommeRecherchee(+recherche);
    setSommeTTCJourLegale(+ttcJLeg); setSommeHTJourLegale(+htJLeg);
    setSommeMoisLegale(+moisLeg); setSommeMoisPrecedentsLegale(+moisPrecsLeg); setSommeRechercheeLegale(+rechercheLeg);
  }, [annonces, filteredAnnonces, searchTerm, searchQuery, filterDateRange, searchName]);

  // ── Filtrage ───────────────────────────────────────────
  useEffect(() => {
    let f = [...annonces];
    if (year)   f = f.filter(a => new Date(a.dateFacture).getFullYear().toString() === year);
    if (month)  f = f.filter(a => (new Date(a.dateFacture).getMonth() + 1).toString() === month.padStart(2, '0'));
    if (day)    f = f.filter(a => new Date(a.dateFacture).getDate().toString() === day.padStart(2, '0'));
    if (searchTerm.trim())  f = f.filter(a => a.numDossier.includes(searchTerm) || a.numAnnonce.includes(searchTerm));
    if (searchQuery.trim()) f = f.filter(a => role === 'ADMIN'
      ? a.reference?.toLowerCase().includes(searchQuery.toLowerCase())
      : a.idJal?.toLowerCase().includes(searchQuery.toLowerCase())
    );
    if (searchName.trim()) {
      const sl = searchName.toLowerCase();
      f = f.filter(a => a.firstname?.toLowerCase().includes(sl) || a.name?.toLowerCase().includes(sl));
    }
    if (filterDateRange && (filterDateRange[0] || filterDateRange[1])) {
      const [s, e] = filterDateRange;
      f = f.filter(a => {
        const d = dayjs(a.dateFacture);
        return (!s || !d.isBefore(s, 'day')) && (!e || d.isBefore(e.add(1, 'day')));
      });
    }
    if (filterDate)   f = f.filter(a => new Date(a.dateFacture).toISOString().split('T')[0] === filterDate);
    if (filterYear)   f = f.filter(a => new Date(a.dateFacture).getFullYear().toString() === filterYear);
    if (filterMonth)  f = f.filter(a => new Date(a.dateFacture).getMonth() + 1 === Number(filterMonth));
    if (filterDay)    f = f.filter(a => new Date(a.dateFacture).getDate() === Number(filterDay));
    if (filterStatus) f = f.filter(a => a.status?.toString() === filterStatus);
    if (filterPayment === 'paid')   f = f.filter(a => a.isPaid === true);
    if (filterPayment === 'unpaid') f = f.filter(a => a.isPaid === false || a.isPaid === undefined);
    setFilteredAnnonces(f);
    setCurrentPage(1);
  }, [annonces, year, month, day, searchTerm, searchQuery, searchName, filterDateRange, filterDate, filterYear, filterMonth, filterDay, filterStatus, role, filterPayment]);

  const formatDate = (date: Date) => {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    const h = date.getHours().toString().padStart(2, '0');
    const mn = date.getMinutes().toString().padStart(2, '0');
    return `${d}/${m}/${y} ${h}:${mn}`;
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredAnnonces.map(a => ({
      ...(role === 'ADMIN' ? { 'Nom et prénom': `${a.firstname || ''} ${a.name || ''}` } : { 'Nom': username }),
      'Numéro de Dossier': a.numDossier, "Numéro d'Annonce": a.numAnnonce,
      'Support': a.nomJal, 'Montant HT': a.montantHTannonce, 'Montant TTC': a.montantTTC,
      'Date de Facture': formatDate(new Date(a.dateFacture)), 'Payée': a.status,
      'Réf Client': a.reference, 'Date de parution': formatDate(new Date(a.dateParrution)),
      'Date de Création': formatDate(new Date(a.createdAt)), 'Texte Annonce': a.textAnnonce,
    })));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Annonces');
    saveAs(new Blob([XLSX.write(wb, { bookType: 'xlsx', type: 'array' })],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'annonces.xlsx');
  };

  const filteredResults = filteredAnnonces.filter(() => true);
  const { paginatedData: paginatedResults, totalPages } = paginate(filteredResults, currentPage);

  // ── Sélection / téléchargement ─────────────────────────
  const toggleSelectAnnonce = (e: React.ChangeEvent<HTMLInputElement>) => {
    const id = e.currentTarget.dataset.fileId!;
    setSelectedAnnonces(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const toggleSelectAllAlo = () => {
    const ids = role === 'CLIENT'
      ? filteredResults.map(a => `pdfFactureAlo-${a.id}`)
      : filteredResults.map(a => `pdfFactureAlo-${a.annonce_id}`);
    setSelectedAnnonces(prev => ids.every(id => prev.includes(id))
      ? prev.filter(id => !ids.includes(id))
      : [...prev, ...ids.filter(id => !prev.includes(id))]);
  };

  const toggleSelectAllLegal = () => {
    if (role !== 'ADMIN') return;
    const ids = filteredResults.map(a => `pdfFacture-${a.annonce_id}`);
    setSelectedAnnonces(prev => ids.every(id => prev.includes(id))
      ? prev.filter(id => !ids.includes(id))
      : [...prev, ...ids.filter(id => !prev.includes(id))]);
  };

  const downloadSelected = async (files: string[]) => {
    if (!files.length) return;
    try {
      const res = await axios.post('/download-factures', { files }, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `factures-${Date.now()}.zip`);
      document.body.appendChild(link); link.click(); link.remove();
    } catch (err) { console.error(err); }
  };

  const dlClient = () => downloadSelected(
    annonces.reduce((acc: string[], a) => {
      if (selectedAnnonces.includes(`pdfFactureAlo-${a.id}`) && a.pdfFactureAlo)
        acc.push(a.pdfFactureAlo.split('/')[2]);
      return acc;
    }, [])
  );

  const dlAdmin = () => {
    const files: string[] = [];
    annonces.forEach(a => {
      if (selectedAnnonces.includes(`pdfFactureAlo-${a.annonce_id}`) && a.pdfFactureAlo) files.push(a.pdfFactureAlo.split('/')[2]);
      if (selectedAnnonces.includes(`pdfFacture-${a.annonce_id}`) && a.pdfFacture) files.push(a.pdfFacture.split('/')[2]);
    });
    downloadSelected(files);
  };

  // ── Avoirs ─────────────────────────────────────────────
  useEffect(() => {
    if (activeTab !== 'avoirs') return;
    const fetch = async () => {
      try { setLoadingAvoirs(true); setCreditNotes(await getAvoirs() || []); }
      catch { toast.error('Impossible de charger les avoirs'); }
      finally { setLoadingAvoirs(false); }
    };
    fetch();
  }, [activeTab]);

  const filteredAvoirs = creditNotes.filter(cn =>
    cn.statut === 'remboursé' && cn.annonce?.User?.id?.toString() === localStorage.getItem('userId')
  );
  const { paginatedData: paginatedAvoirs, totalPages: totalPagesAvoirs } = paginate(filteredAvoirs, currentAvoirsPage);

  const handleSelectAvoir = (checked: boolean, id: number) =>
    setSelectedAvoirs(prev => checked ? [...prev, id] : prev.filter(x => x !== id));

  const handleDownloadAvoir = (id: number) => {
    try { downloadAvoirFacture(id); toast.success('Téléchargement lancé...'); }
    catch { toast.error('Erreur lors du téléchargement'); }
  };

  const handleDownloadSelectedAvoirs = () => {
    if (!selectedAvoirs.length) { toast.info('Sélectionnez au moins un avoir'); return; }
    selectedAvoirs.forEach(handleDownloadAvoir);
    setSelectedAvoirs([]);
  };

  // ── Render ─────────────────────────────────────────────
  return (
    <div>
      <div>
        {/* Onglets */}
        <div className="tabs-container">
          <button className={`btn ${activeTab === 'factures' ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => { trackMenuClick('factures-onglet-factures', 'Onglet Factures'); setActiveTab('factures'); }}>
            Factures
          </button>
          <button className={`btn ${activeTab === 'avoirs' ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => { trackMenuClick('factures-onglet-avoirs', 'Onglet Avoirs'); setActiveTab('avoirs'); }}>
            Avoirs remboursés
          </button>
          {role === 'ADMIN' && (
            <>
            <button className="btn" style={{ backgroundColor: '#4BB0C0', color: 'white' }} onClick={() => openEditModal()}>
              Modifier la facture
            </button>
            </>
          )}
            <button 
            className={`btn ${activeTab === 'annuaire' ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => { 
              trackMenuClick('factures-onglet-annuaire', 'Onglet Achats Annuaire'); 
              setActiveTab('annuaire'); 
            }}
          >
            <FontAwesomeIcon icon={faShoppingCart} style={{ marginRight: '8px' }} />
            Achats Annuaire/Export
          </button>
          
        </div>

        <EmailReminderModal isModalOpen={isModalOpen2} setIsModalOpen={setIsModalOpen2}
          currentAnnonce={currentAnnonce} setCurrentAnnonce={setCurrentAnnonce} />

        {showModal && <EditFactureModal show={showModal} onClose={() => setShowModal(false)} />}

        {/* ══ ONGLET FACTURES ══ */}
        {activeTab === 'factures' && (
          <>
            {/* Filtres */}
            <div className="row g-2 mb-4 align-items-center">
              <div className="col-12 col-md-6 col-lg-3">
                <div className="search-group">
                  <label htmlFor="search-name" className="form-label small mb-1">Nom / Prénom</label>
                  <input id="search-name" type="text" className="form-control form-control-sm"
                    value={searchName} onChange={e => setSearchName(e.target.value)} />
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <div className="search-group">
                  <label htmlFor="search-dossier" className="form-label small mb-1">Dossier / Annonce</label>
                  <input id="search-dossier" type="text" className="form-control form-control-sm"
                    value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-2">
                <div className="search-group">
                  <label htmlFor="search-client" className="form-label small mb-1">
                    {role === 'ADMIN' ? 'Réf. Client' : 'Id JAL'}
                  </label>
                  <input id="search-client" type="text" className="form-control form-control-sm"
                    value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <div className="search-group">
                  <label className="form-label small mb-1">Période</label>
                  <RangePicker className="w-100" style={{ height: '31px', fontSize: '0.875rem' }}
                    format="DD/MM/YYYY"
                    onChange={dates => setFilterDateRange(dates as [Dayjs | null | undefined, Dayjs | null | undefined])}
                    size="small" />
                </div>
              </div>
            </div>

            {/* Filtres paiement (ADMIN) */}
            {role === 'ADMIN' && (
              <div className="d-flex flex-wrap gap-2 mb-3">
                {(['all', 'paid', 'unpaid'] as const).map(v => (
                  <button key={v} type="button" className="btn position-relative"
                    style={{ backgroundColor: filterPayment === v ? '#4BB0C0' : '#F4A261', color: 'white' }}
                    onClick={() => setFilterPayment(v)}>
                    {v === 'all' && 'Toutes'}
                    {v === 'paid' && <><FaCheckCircle className="me-1" />Payées</>}
                    {v === 'unpaid' && <><FaTimesCircle className="me-1" />Non payées</>}
                    <span className="badge rounded-pill ms-2" style={{ backgroundColor: 'white', color: '#4bb0c0' }}>
                      {v === 'all' ? totalCount : v === 'paid' ? paidCount : unpaidCount}
                    </span>
                  </button>
                ))}
              </div>
            )}

            {/* Métriques */}
            <div className="metrics-table-wrapper">
              <table>
                <thead>
                  <tr>
                    {role === 'ADMIN' && <th>Somme TTC</th>}
                    {role === 'CLIENT' && <th></th>}
                    <th>Facture du jour</th><th>Facture du mois</th>
                    <th>Facture du mois précédent</th><th>Facture recherchée</th>
                  </tr>
                </thead>
                <tbody>
                  {role === 'CLIENT' && (
                    <tr>
                      <td style={{ fontWeight: 'bold' }}>Somme TTC</td>
                      <td>{sommeTTCJourAlo.toFixed(2)} € TTC</td>
                      <td>{sommeMois.toFixed(2)} €</td>
                      <td>{sommeMoisPrecedents.toFixed(2)} €</td>
                      <td>{sommeRecherchee.toFixed(2)} €</td>
                    </tr>
                  )}
                  {role === 'ADMIN' && (
                    <>
                      <tr>
                        <td style={{ fontWeight: 'bold' }}>ALO</td>
                        <td>{sommeTTCJourAlo.toFixed(2)} € TTC<br /><small>{sommeHTJourAlo.toFixed(2)} € HT</small></td>
                        <td>{sommeMois.toFixed(2)} €</td><td>{sommeMoisPrecedents.toFixed(2)} €</td><td>{sommeRecherchee.toFixed(2)} €</td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: 'bold' }}>Légale</td>
                        <td>{sommeTTCJourLegale.toFixed(2)} € TTC<br /><small>{sommeHTJourLegale.toFixed(2)} € HT</small></td>
                        <td>{sommeMoisLegale.toFixed(2)} €</td><td>{sommeMoisPrecedentsLegale.toFixed(2)} €</td><td>{sommeRechercheeLegale.toFixed(2)} €</td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: 'bold' }}>Écart</td>
                        <td>{(sommeTTCJourAlo - sommeTTCJourLegale).toFixed(2)} € TTC<br /><small>{(sommeHTJourAlo - sommeHTJourLegale).toFixed(2)} € HT</small></td>
                        <td>{(sommeMois - sommeMoisLegale).toFixed(2)} €</td>
                        <td>{(sommeMoisPrecedents - sommeMoisPrecedentsLegale).toFixed(2)} €</td>
                        <td>{(sommeRecherchee - sommeRechercheeLegale).toFixed(2)} €</td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>

            {/* Boutons */}
            <div className="action-buttons-wrapper">
              {role === 'CLIENT' && (
                <button className="btn btn-secondary custom-btn" onClick={toggleSelectAllAlo}
                  style={{ backgroundColor: '#4BB0C0', color: 'white' }}>
                  {filteredResults.every(a => selectedAnnonces.includes(`pdfFactureAlo-${a.id}`)) ? 'Désélectionner Tout' : 'Sélectionner Tout'}
                </button>
              )}
              {role === 'ADMIN' && (
                <>
                  <button className="btn btn-secondary custom-btn" onClick={toggleSelectAllAlo}
                    style={{ backgroundColor: '#4BB0C0', color: 'white' }}>
                    {filteredResults.every(a => selectedAnnonces.includes(`pdfFactureAlo-${a.annonce_id}`)) ? 'Tout Désélectionner ALO' : 'Tout Sélectionner ALO'}
                  </button>
                  <button className="btn btn-secondary custom-btn" onClick={toggleSelectAllLegal}
                    style={{ backgroundColor: '#4BB0C0', color: 'white' }}>
                    {filteredResults.every(a => selectedAnnonces.includes(`pdfFacture-${a.annonce_id}`)) ? 'Tout Désélectionner Légale' : 'Tout Sélectionner Légale'}
                  </button>
                </>
              )}
              <button className="btn btn-primary custom-btn2"
                onClick={role === 'CLIENT' ? dlClient : dlAdmin}>
                Télécharger les factures
              </button>
              <button className="btn btn-primary custom-btn2" onClick={exportToExcel}
                style={{ backgroundColor: '#4BB0C0', color: 'white' }}>
                Exporter en Excel
              </button>
            </div>

            {/* Tableau principal */}
            {loading ? <LoaderAnnonce /> : (
              <div className="facture-table-wrapper">
                <div className="facture-table-container">
                  <table className="table wrap-table">

                    {/* ── colgroup : contrôle des largeurs ── */}
                    {role === 'CLIENT' ? (
                      <colgroup>
                        <col className="col-w-facture" />  {/* Facture */}
                        <col className="col-w-nom" />      {/* Nom */}
                        <col className="col-w-dossier" />  {/* Dossier */}
                        <col className="col-w-date" />     {/* Date */}
                        <col className="col-w-tarif" />    {/* Tarif ALO */}
                        <col className="col-w-jal" />      {/* ID JAL */}
                        <col className="col-w-annonce" />  {/* Annonce */}
                        <col className="col-w-type" />     {/* Type */}
                        <col className="col-w-statut" />   {/* Statut */}
                      </colgroup>
                    ) : (
                      <colgroup>
                        <col className="col-w-facture" />    {/* Facture ALO */}
                        <col className="col-w-legale" />     {/* Facture légale */}
                        <col className="col-w-nom" />        {/* Nom */}
                        <col className="col-w-dossier" />    {/* Dossier */}
                        <col className="col-w-date" />       {/* Date */}
                        <col className="col-w-tarif-leg" />  {/* Tarif légale */}
                        <col className="col-w-tarif" />      {/* Tarif ALO */}
                        <col className="col-w-ecart" />      {/* Écart */}
                        <col className="col-w-jal" />        {/* Réf Client */}
                        <col className="col-w-annonce" />    {/* Annonce */}
                        <col className="col-w-type" />       {/* Type */}
                        <col className="col-w-statut" />     {/* Statut */}
                      </colgroup>
                    )}

                    <thead>
                      <tr>
                        <th>Facture</th>
                        {role === 'ADMIN' && <th>Facture legal2digital</th>}
                        <th>Nom et Prénom</th>
                        <th>Dossier</th>
                        <th>Date Facture</th>
                        {role === 'ADMIN' && <th>Tarif Légale (-25%)</th>}
                        <th>Tarif ALO</th>
                        {role === 'ADMIN' && <th>Écart (TTC)</th>}
                        <th>{role === 'ADMIN' ? 'Référence Client' : 'ID JAL'}</th>
                        <th>Annonce</th>
                        <th>Type</th>
                        <th>Statut de paiement</th>
                      </tr>
                    </thead>

                    <tbody>
                      {paginatedResults.map((annonce, index) => (
                        <tr key={index}>
                          {/* Facture ALO – CLIENT */}
                          {role === 'CLIENT' && (
                            <td className="col-facture">
                              <input type="checkbox"
                                data-file-id={`pdfFactureAlo-${annonce.id}`}
                                checked={selectedAnnonces.includes(`pdfFactureAlo-${annonce.id}`)}
                                onChange={toggleSelectAnnonce} />
                              <a href={`${API_URL}/download-factures/${annonce.pdfFactureAlo.split('/')[2]}`}
                                download target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-sm btn-outline-secondary" title="Télécharger PDF">
                                  <FontAwesomeIcon icon={faFilePdf} />
                                </button>
                              </a>
                            </td>
                          )}

                          {/* Facture ALO – ADMIN */}
                          {role === 'ADMIN' && (
                            <td className="col-facture">
                              <input type="checkbox"
                                data-file-id={`pdfFactureAlo-${annonce.annonce_id}`}
                                checked={selectedAnnonces.includes(`pdfFactureAlo-${annonce.annonce_id}`)}
                                onChange={toggleSelectAnnonce} />
                              <a href={`${API_URL}/download-factures/${annonce.pdfFactureAlo.split('/')[2]}`}
                                download target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-sm btn-outline-secondary" title="Télécharger PDF">
                                  <FontAwesomeIcon icon={faFilePdf} />
                                </button>
                              </a>
                            </td>
                          )}

                          {/* Facture légale – ADMIN */}
                          {role === 'ADMIN' && (
                            <td className="col-facture">
                              <input type="checkbox"
                                data-file-id={`pdfFacture-${annonce.annonce_id}`}
                                checked={selectedAnnonces.includes(`pdfFacture-${annonce.annonce_id}`)}
                                onChange={toggleSelectAnnonce} />
                              <a href={`${API_URL}/download-factures/${annonce.pdfFacture.split('/')[2]}`}
                                download target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-sm btn-outline-secondary" title="Télécharger PDF">
                                  <FontAwesomeIcon icon={faFilePdf} />
                                </button>
                              </a>
                            </td>
                          )}

                          {/* Nom */}
                          <td title={role === 'ADMIN' ? `${annonce.firstname} ${annonce.name}` : username}>
                            {role === 'ADMIN' ? `${annonce.firstname} ${annonce.name}` : username}
                          </td>

                          {/* Dossier */}
                          <td title={annonce.numDossier}>{annonce.numDossier}</td>

                          {/* Date facture */}
                          <td title={formatDate(new Date(annonce.dateFacture))}>
                            {formatDate(new Date(annonce.dateFacture))}
                          </td>

                          {/* Tarif légale (ADMIN) */}
                          {role === 'ADMIN' && (
                            <td style={{ fontWeight: 'bold', fontSize: '0.9em' }}
                              title={`${getTarifReduitTTC(annonce.legalMoTTC)} € TTC`}>
                              {getTarifReduitTTC(annonce.legalMoTTC)} € TTC
                            </td>
                          )}

                          {/* Tarif ALO */}
                          <td>
                            {role === 'ADMIN' && <div>{Number(annonce.montantHTannonce)} € HT</div>}
                            <div style={{ fontWeight: 'bold' }}>
                              {annonce.montantTTC} € TTC
                              {typeof annonce.montantFinalTTC === 'number' && annonce.montantFinalTTC !== annonce.montantTTC && (
                                <div style={{ color: '#ff9e28ff', fontSize: '0.72em', lineHeight: '1.1em' }}>
                                  Après points :&nbsp;
                                  <span style={{ fontWeight: 'bold' }}>
                                    {annonce.montantFinalTTC.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} € TTC
                                  </span>
                                </div>
                              )}
                            </div>
                          </td>

                          {/* Écart (ADMIN) */}
                          {role === 'ADMIN' && (
                            <td>{Math.max(0, annonce.montantTTC - getTarifReduitTTC(annonce.legalMoTTC)).toFixed(2)} €</td>
                          )}

                          {/* Réf / ID JAL */}
                          <td title={role === 'ADMIN' ? annonce.reference : annonce.idJal}>
                            {role === 'ADMIN' ? annonce.reference : annonce.idJal}
                          </td>

                          {/* Annonce (support) — tronqué avec title tooltip */}
                          <td title={annonce.nomJal}>{annonce.nomJal}</td>

                          {/* Type — tronqué avec title tooltip */}
                          <td title={annonce.type_annonce}>{annonce.type_annonce}</td>

                          {/* Statut paiement */}
                          <td className="col-statut">
                            {annonce.isPaid ? (
                              <FaCheckCircle style={{ color: 'green', fontSize: '1.2rem' }} title="Payé" />
                            ) : (
                              <Popover
                                content={
                                  <div>
                                    <div>Relancer client + utilisateur</div>
                                    {(annonce?.reminderCount ?? 0) > 0 && (
                                      <small style={{ color: '#999', display: 'block', marginTop: 4 }}>
                                        {annonce.reminderCount} relance(s) envoyée(s)
                                        {annonce.lastReminderDate && (
                                          <div style={{ fontSize: 10, marginTop: 2 }}>
                                            Dernière : {new Date(annonce.lastReminderDate).toLocaleString('fr-FR', {
                                              day: '2-digit', month: '2-digit', year: 'numeric',
                                              hour: '2-digit', minute: '2-digit',
                                            })}
                                          </div>
                                        )}
                                      </small>
                                    )}
                                  </div>
                                }
                                trigger="hover"
                              >
                                <Button onClick={() => handleClickReminder(annonce)}
                                  style={{
                                    background: '#eb8635', border: 'none',
                                    display: 'flex', flexDirection: 'row',
                                    alignItems: 'center', justifyContent: 'center',
                                    gap: 8, padding: '7px 10px', height: 'auto',
                                    width: '100%', whiteSpace: 'normal', borderRadius: 6,
                                  }}>
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, flex: 1 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                      {(annonce?.reminderCount ?? 0) > 0 && (
                                        <span style={{
                                          backgroundColor: '#fff', color: '#eb8635', borderRadius: '50%',
                                          width: 18, height: 18, display: 'flex', alignItems: 'center',
                                          justifyContent: 'center', fontSize: 10, fontWeight: 'bold', flexShrink: 0,
                                        }}>
                                          {annonce.reminderCount}
                                        </span>
                                      )}
                                      <span style={{ color: '#FFF', fontWeight: 'bold', fontSize: 12 }}>Non payé</span>
                                    </div>
                                    {(annonce?.reminderCount ?? 0) > 0 && annonce.lastReminderDate && (
                                      <span style={{ fontSize: 10, color: '#FFF', opacity: 0.85 }}>
                                        {new Date(annonce.lastReminderDate).toLocaleDateString('fr-FR')}
                                      </span>
                                    )}
                                  </div>
                                  <FontAwesomeIcon icon={faPaperPlane} color="#FFF" style={{ fontSize: 12, flexShrink: 0 }} />
                                </Button>
                              </Popover>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="facture-pagination-footer">
                  <PaginationControls currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
                </div>
              </div>
            )}
          </>
        )}

        {showModal2 && (
          <EditAnnonceModal show={showModal2} annonce={selectedAnnonce2}
            onClose={() => setShowModal2(false)}
            onSave={(u) => console.log('Annonce modifiée :', u)} />
        )}

        {/* ══ ONGLET AVOIRS ══ */}
        {activeTab === 'avoirs' && (
          <>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5>Avoirs remboursés</h5>
                <small className="text-muted">Liste des avoirs remboursés et téléchargeables</small>
              </div>
              <div className="d-flex gap-2">
                <button className="btn btn-outline-secondary" onClick={() => setSelectedAvoirs([])}>Annuler la sélection</button>
                <button className="btn btn-primary" onClick={handleDownloadSelectedAvoirs}>Télécharger sélection</button>
              </div>
            </div>

            {loadingAvoirs ? <LoaderAnnonce /> : (
              <div className="facture-table-wrapper">
                <div className="facture-table-container">
                  <table className="table wrap-table table-hover">
                    <colgroup>
                      <col style={{ width: '40px' }} />
                      <col style={{ width: '160px' }} />
                      <col style={{ width: '200px' }} />
                      <col style={{ width: '100px' }} />
                      <col style={{ width: '200px' }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Client</th>
                        <th>Annonce / Dossier</th>
                        <th>Montant</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedAvoirs.length === 0 ? (
                        <tr><td colSpan={5} className="text-center py-4"><small>Aucun avoir remboursé</small></td></tr>
                      ) : paginatedAvoirs.map((avoir: SimpleCreditNote) => (
                        <tr key={avoir.id}>
                          <td className="col-facture">
                            <input type="checkbox" checked={selectedAvoirs.includes(avoir.id)}
                              onChange={e => handleSelectAvoir(e.target.checked, avoir.id)} />
                          </td>
                          <td title={`${avoir.annonce?.User?.firstname || ''} ${avoir.annonce?.User?.name || ''}`}>
                            {avoir.annonce?.User?.firstname || 'N/A'} {avoir.annonce?.User?.name || ''}
                          </td>
                          <td>
                            <div>{avoir.annonce?.numAnnonce || 'N/A'}</div>
                            <div className="text-muted small">Dossier : {avoir.annonce?.numDossier || 'N/A'}</div>
                          </td>
                          <td><strong>{Number(avoir.montant_avoir || 0)} €</strong></td>
                          <td className="col-statut">
                            <button className="btn btn-sm btn-outline-primary me-2"
                              onClick={() => openFactureInNewTab(avoir.id)}>
                              <FaEye /> Voir
                            </button>
                            <button className="btn btn-sm btn-outline-secondary"
                              onClick={() => handleDownloadAvoir(avoir.id)}>
                              <FaDownload /> Télécharger
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="facture-pagination-footer">
                  <PaginationControls currentPage={currentAvoirsPage} totalPages={totalPagesAvoirs || 1} onPageChange={setCurrentAvoirsPage} />
                </div>
              </div>
            )}
          </>
        )}

          {activeTab === 'annuaire' && (
            <div className="mt-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <h5>Achats Annuaire</h5>
                  <small className="text-muted">
                    {role === 'ADMIN' 
                      ? "Historique des achats de places premium et d'exports par les clients" 
                      : "Votre historique d'achats sur l'annuaire"}
                  </small>
                </div>
              </div>
              {/* ✅ PASSEZ LE ROLE AU COMPOSANT */}
              <ClientsPurchasesTable userRole={role} />
            </div>
          )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default GestionFactureUser;